import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeftIcon, CloseIcon } from '@domain-group/fe-co-icon';
import * as styles from './allhomes-mobile-dialog-frame.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesMobileDialogFrame = props => ___EmotionJSX("div", {
  css: styles.container
}, ___EmotionJSX("div", {
  css: styles.scrollableRegion(props.applyButton)
}, ___EmotionJSX("div", {
  css: styles.heading(props.extraStyles.heading)
}, props.closeButton && props.backButton === null && ___EmotionJSX("button", {
  css: /*#__PURE__*/_css([styles.toolbarButton, styles.closeButton(props.extraStyles.closeButton)]),
  type: "button",
  onClick: props.onClose,
  "aria-label": "Close"
}, ___EmotionJSX(CloseIcon, {
  size: "custom",
  css: styles.closeButtonIcon
})), props.closeButton && props.backButton !== null && ___EmotionJSX("button", {
  css: /*#__PURE__*/_css([styles.toolbarButton, styles.backButton]),
  type: "button",
  onClick: props.onClose
}, ___EmotionJSX(ChevronLeftIcon, {
  size: "custom",
  css: styles.backButtonIcon
}), ___EmotionJSX("span", {
  css: styles.backButtonText
}, props.backButton)), ___EmotionJSX("span", {
  css: styles.title(props.extraStyles.title)
}, props.title), props.rightButton !== null && ___EmotionJSX("button", {
  css: /*#__PURE__*/_css([styles.toolbarButton, styles.rightButton]),
  type: "button",
  onClick: props.onRightButton,
  disabled: props.rightButtonDisabled
}, ___EmotionJSX("span", {
  css: styles.rightButtonText
}, props.rightButton))), ___EmotionJSX("div", null, props.children)), props.applyButton !== null && ___EmotionJSX("div", {
  css: styles.applyContainer
}, ___EmotionJSX("button", {
  type: "button",
  css: styles.applyButton,
  onClick: props.onApplyButton
}, props.applyButton)));
AllhomesMobileDialogFrame.propTypes = {
  title: PropTypes.string.isRequired,
  closeButton: PropTypes.bool,
  backButton: PropTypes.string,
  rightButton: PropTypes.string,
  applyButton: PropTypes.string,
  onRightButton: PropTypes.func,
  onApplyButton: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node,
  rightButtonDisabled: PropTypes.bool,
  extraStyles: PropTypes.shape({
    heading: PropTypes.shape({}),
    title: PropTypes.shape({}),
    closeButton: PropTypes.shape({})
  })
};
AllhomesMobileDialogFrame.defaultProps = {
  closeButton: false,
  backButton: null,
  rightButton: null,
  applyButton: null,
  onClose: () => {},
  onRightButton: () => {},
  onApplyButton: () => {},
  children: [],
  rightButtonDisabled: false,
  extraStyles: {}
};
export default AllhomesMobileDialogFrame;
export { AllhomesMobileDialogFrame as BaseAllhomesMobileDialogFrame };